import { TitleCasePipe } from '@angular/common';
import { Component, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { interval, startWith, Subscription, switchMap, takeWhile } from 'rxjs';
import { DataService } from 'src/app/services/data.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-seo-off-page-campaigns-form',
  templateUrl: './seo-off-page-campaigns-form.component.html',
  styleUrls: ['./seo-off-page-campaigns-form.component.css'],
})
export class SeoOffPageCampaignsFormComponent implements OnDestroy {
  url_aux: string = 'seoOffpageCampaigns';
  url: string = 'seoKeywordDiscoveries';
  url_two: string = 'users/findLocation';
  id!: string;
  form!: FormGroup;
  isViewOnly: boolean = false;
  isLoading: boolean = false;
  private reviewPollingSub?: Subscription;

  resultsAvailable: boolean = false;
  listLocation: any[] = [];
  uniqueKeywordUrls: string = '';
  newExistingRecord: boolean = false;

  @ViewChild('textareaUrls') textareaUrls!: ElementRef;

  resumenCards = [
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'SEO',
      route: '/marketing',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-arrow-trend-up',
      bgClass: 'bg-white',
      desc: 'ADS',
      route: '/marketing/ads',
    },
    {
      label: '',
      value: '', //0
      icon: 'fa-solid fa-people-line',
      bgClass: 'bg-white',
      desc: 'SOCIAL',
      route: '/marketing/social/strategy',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'GEO',
      route: '',
    },
    
  ];

  // landingTypes = [
  //   { value: 'homepage', label: 'Homepage' },
  //   { value: 'main_landing', label: 'Main Landing' },
  //   { value: 'city_page', label: 'City Page' },
  //   { value: 'service_page', label: 'Service Page' },
  //   { value: 'industry_page', label: 'Industry Page' },
  //   { value: 'local_hub', label: 'Local Hub' },
  //   { value: 'other', label: 'Other' },
  // ];

  // campaignTypes = [
  //   { value: 'local_citation', label: 'Local Citation' },
  //   { value: 'directory', label: 'Directory' },
  //   { value: 'guest_post', label: 'Guest Post' },
  //   { value: 'brand_mention', label: 'Brand Mention' },
  //   { value: 'niche_edit', label: 'Niche Edit' },
  //   { value: 'pr', label: 'PR' },
  //   { value: 'partner_link', label: 'Partner Link' },
  //   { value: 'mixed', label: 'Mixed' },
  // ];

  statuses = [
    { value: 'planned', label: 'Planned' },
    { value: 'research', label: 'Research' },
    { value: 'approved', label: 'Approved' },
    { value: 'in_progress', label: 'In Progress' },
    { value: 'completed', label: 'Completed' },
    { value: 'paused', label: 'Paused' },
    { value: 'failed', label: 'Failed' },
  ];

  // services = [
  //   { value: 'courier', label: 'Courier' },
  //   { value: 'task_runner', label: 'Task Runner' },
  // ];

  locations = [
    { value: 'orlando_fl', label: 'Orlando, FL' },
    { value: 'tampa_fl', label: 'Tampa, FL' },
    { value: 'naples_fl', label: 'Naples, FL' },
    { value: 'west_palm_beach_fl', label: 'West Palm Beach, FL' },
    { value: 'boca_raton_fl', label: 'Boca Raton, FL' },
  ];

  channels = [
    { value: 'google_seo', label: 'Google SEO' },
    { value: 'google_ads', label: 'Google Ads' },
    { value: 'facebook_ads', label: 'Facebook Ads' },
    { value: 'instagram_ads', label: 'Instagram Ads' },
    { value: 'tiktok_ads', label: 'TikTok Ads' },
    { value: 'linkedin_ads', label: 'LinkedIn Ads' },
    { value: 'twitter_ads', label: 'Twitter Ads' },
    { value: 'other', label: 'Other' },
  ];

  universes = [
    { value: 'courier', label: 'Courier' },
    { value: 'runner', label: 'Runner' },
  ];

  categories = [
    { value: 'company_brand', label: 'Company Brand' },
    { value: 'same_day_courier', label: 'Same-Day Courier' },
    { value: 'rush_courier', label: 'Rush Courier' },
    { value: 'scheduled_courier', label: 'Scheduled Courier' },
    { value: 'vip_courier', label: 'VIP Courier' },
    { value: 'concierge_courier', label: 'Concierge Courier' },
    { value: 'business_courier', label: 'Business Courier' },
    { value: 'legal_services', label: 'Legal Services' },
    { value: 'long_distance_courier', label: 'Long Distance Courier' },
    { value: 'last_mile_services', label: 'Last Mile Services' },
    { value: 'local_courier_services', label: 'Local Courier Services' },
  ];

  conversionGoals = [
    {
      value: 'phone_calls_quote_requests',
      label: 'Phone Calls & Quote Requests',
    },
    { value: 'online_bookings', label: 'Online Bookings' },
    { value: 'contact_form_submissions', label: 'Contact Form Submissions' },
    { value: 'email_inquiries', label: 'Email Inquiries' },
    { value: 'live_chat_conversations', label: 'Live Chat Conversations' },
    { value: 'get_a_quote_requests', label: 'Get a Quote Requests' },
    { value: 'quote_requests', label: 'Quote Requests' },
    { value: 'bookings', label: 'Bookings' },
    { value: 'customer_app_downloads', label: 'Customer App Downloads' },
    { value: 'customer_app_signups', label: 'Customer App Signups' },
    { value: 'business_account_signups', label: 'Business Account Signups' },
    { value: 'driver_signups', label: 'Driver Signups' },
  ];

  keywordIntents = [
    { value: 'high_intent_local', label: 'High-Intent Local' },
    { value: 'broad_commercial', label: 'Broad Commercial' },
    { value: 'mixed_high_intent', label: 'Mixed High-Intent' },
    { value: 'informational', label: 'Informational' },
    { value: 'navigational', label: 'Navigational' },
    { value: 'brand_intent', label: 'Brand Intent' },
  ];

  keywordModes = [
    { value: 'ai_optimized', label: 'AI Optimized' },
    { value: 'revenue_opportunities', label: 'Revenue Opportunities' },
    { value: 'high_commercial_value', label: 'High Commercial Value' },
    { value: 'conversion_focused', label: 'Conversion Focused' },
    { value: 'high_volume', label: 'High Volume' },
    { value: 'authority_building', label: 'Authority Building' },
  ];

  competitionTargets = [
    { value: 'strategic_mix', label: 'Strategic Mix' },
    { value: 'medium_competition', label: 'Medium Competition' },
    { value: 'high_competition', label: 'High Competition' },
    { value: 'market_leader_keywords', label: 'Market Leader Keywords' },
  ];

  objectives = [
    { value: 'conversion_growth', label: 'Conversion Growth' },
    { value: 'ranking_growth', label: 'Ranking Growth' },
    { value: 'authority_growth', label: 'Authority Growth' },
    { value: 'strategic_growth_mix', label: 'Strategic Growth Mix' },
  ];

  landingStrategies = [
    { value: 'homepage', label: 'Homepage' },
    { value: 'main_landing', label: 'Main Landing' },
    { value: 'city_page', label: 'City Page' },
    { value: 'service_page', label: 'Service Page' },
    { value: 'industry_page', label: 'Industry Page' },
    { value: 'local_hub', label: 'Local Hub' },
    { value: 'other', label: 'Other' },
    { value: 'system_suggests', label: 'System suggests' },
  ];

  urlStrategies = [
    { value: 'homepage', label: 'Homepage' },
    { value: 'main_landing', label: 'Main Landing' },
    { value: 'city_page', label: 'City Page' },
    { value: 'service_page', label: 'Service Page' },
    { value: 'industry_page', label: 'Industry Page' },
    { value: 'local_hub', label: 'Local Hub' },
    { value: 'other', label: 'Other' },
    { value: 'system_suggests', label: 'System suggests' },
  ];

  actionTypes = [
    { value: 'homepage', label: 'Homepage' },
    { value: 'main_landing', label: 'Main Landing' },
    { value: 'city_page', label: 'City Page' },
    { value: 'service_page', label: 'Service Page' },
    { value: 'industry_page', label: 'Industry Page' },
    { value: 'local_hub', label: 'Local Hub' },
    { value: 'other', label: 'Other' },
    { value: 'system_suggests', label: 'System suggests' },
  ];

  priorities = [
    { value: 'low', label: 'Low' },
    { value: 'medium', label: 'Medium' },
    { value: 'high', label: 'High' },
    { value: 'critical', label: 'Critical' },
  ];

  selectedLocation: string = '';
  locationSelected: boolean = false;
  universeSelected: boolean = false;
  filteredUniverses: string[] = [];
  uniqueUniverses: string[] = [];
  selectedUniverse: string = '';
  filteredCategories: string[] = [];
  uniqueCategories: string[] = [];
  selectedCategory: string = '';
  uniqueLocations: string[] = [];
  filteredLocations: string[] = [];
  hasSearched: boolean = false;
  searchText = '';
  filteredData: Array<any> = [];
  data: Array<any> = [];
  searched: boolean = false;
  currentPage: number = 1;
  morePages: boolean = true;
  itemsPerPage: number = 50;
  type = '';

  matchedCategories = new Set<string>();
  matchedGoals = new Set<string>();
  matchedIntents = new Set<string>();
  matchedModes = new Set<string>();
  matchedCompetitions = new Set<string>();
  matchedObjectives = new Set<string>();
  matchedUniverses = new Set<string>();
  formUniverses: { value: string; label: string }[] = [];
  formCategories: { value: string; label: string }[] = [];
  searchSuggestions: string[] = [];

  // cities = [
  //   { value: 'miami', label: 'Miami' },
  //   { value: 'fort_lauderdale', label: 'Fort Lauderdale' },
  //   { value: 'west_palm_beach', label: 'West Palm Beach' },
  //   { value: 'orlando', label: 'Orlando' },
  //   { value: 'tampa', label: 'Tampa' },
  //   { value: 'new_york', label: 'New York' },
  //   { value: 'los_angeles', label: 'Los Angeles' },
  //   { value: 'chicago', label: 'Chicago' },
  //   { value: 'houston', label: 'Houston' },
  //   { value: 'phoenix', label: 'Phoenix' },
  //   { value: 'philadelphia', label: 'Philadelphia' },
  //   { value: 'san_antonio', label: 'San Antonio' },
  //   { value: 'san_diego', label: 'San Diego' },
  //   { value: 'dallas', label: 'Dallas' },
  //   { value: 'san_jose', label: 'San Jose' },
  //   { value: 'Miami Beach', label: 'Miami Beach' },
  // ];

  // industries = [
  //   { value: 'law_firm', label: 'Law Firm' },
  //   { value: 'financial_services', label: 'Financial Services' },
  //   { value: 'insurance', label: 'Insurance' },
  //   { value: 'consulting', label: 'Consulting' },
  //   { value: 'business_services', label: 'Business Services' },
  //   { value: 'recruiting_staffing', label: 'Recruiting & Staffing' },
  //   { value: 'translation_services', label: 'Translation Services' },

  //   { value: 'medical_clinic', label: 'Medical Clinic' },
  //   { value: 'dental', label: 'Dental' },
  //   { value: 'chiropractic', label: 'Chiropractic' },

  //   { value: 'auto_repair', label: 'Auto Repair' },
  //   { value: 'tire_shop', label: 'Tire Shop' },
  //   { value: 'towing', label: 'Towing' },

  //   { value: 'electronics', label: 'Electronics' },
  //   { value: 'beauty_products', label: 'Beauty Products' },
  //   { value: 'pet_supplies', label: 'Pet Supplies' },
  //   { value: 'sporting_goods', label: 'Sporting Goods' },

  //   { value: 'manufacturing', label: 'Manufacturing' },
  //   { value: 'logistics', label: 'Logistics' },
  //   { value: 'warehousing', label: 'Warehousing' },
  //   { value: 'engineering', label: 'Engineering' },
  //   { value: 'industrial_equipment', label: 'Industrial Equipment' },
  //   { value: 'packaging', label: 'Packaging' },
  //   { value: 'coffee_industry', label: 'Coffee Industry' },
  //   { value: 'banana_production', label: 'Banana Production' },
  //   { value: 'agricultural_supplies', label: 'Agricultural Supplies' },

  //   { value: 'government_services', label: 'Government Services' },
  //   { value: 'security_services', label: 'Security Services' },

  //   { value: 'other_local_business', label: 'Other Local Business' },
  //   { value: 'law-firms', label: 'Law Firms' },
  // ];

  // targetAnchorsOptions: {
  //   shortTerm: { value: string; status: string }[];
  //   mediumTerm: { value: string; status: string }[];
  //   longTerm: { value: string; status: string }[];
  // } = { shortTerm: [], mediumTerm: [], longTerm: [] };
  // suggestedKeywordsOptions: {
  //   shortTerm: { value: string; status: string }[];
  //   mediumTerm: { value: string; status: string }[];
  //   longTerm: { value: string; status: string }[];
  // } = { shortTerm: [], mediumTerm: [], longTerm: [] };
  // suggestedAnchorsOptions: {
  //   shortTerm: { value: string; status: string }[];
  //   mediumTerm: { value: string; status: string }[];
  //   longTerm: { value: string; status: string }[];
  // } = { shortTerm: [], mediumTerm: [], longTerm: [] };
  // targetLocationsOptions: {
  //   shortTerm: { value: string; status: string }[];
  //   mediumTerm: { value: string; status: string }[];
  //   longTerm: { value: string; status: string }[];
  // } = { shortTerm: [], mediumTerm: [], longTerm: [] };

  // activeAddTerm: string | null = null;

  // targetUrls = [
  //   { value: 'courierandbeyond.com/', label: 'courierandbeyond.com' },
  //   { value: '/same-day-courier/', label: '/same-day-courier/' },
  //   { value: '/rush-courier-service/', label: '/rush-courier-service/' },
  //   {
  //     value: '/last-mile-courier-services/',
  //     label: '/last-mile-courier-services/',
  //   },
  //   { value: '/courier-for-business/', label: '/courier-for-business/' },
  //   { value: '/runner-services/', label: '/runner-services/' },
  //   { value: '/vip-courier-service', label: '/vip-courier-service' },
  //   {
  //     value: '/concierge-related-services/',
  //     label: '/concierge-related-services/',
  //   },
  //   { value: '/courier-beyond-about-us/', label: '/courier-beyond-about-us/' },
  //   { value: '/private-policy/', label: '/private-policy/' },
  //   { value: '/trust-safety/', label: '/trust-safety/' },
  //   { value: '/blog/', label: '/blog/' },
  //   {
  //     value: '/logistics/fees-and-penalties/',
  //     label: '/logistics/fees-and-penalties/',
  //   },
  //   { value: '/faq/', label: '/faq/' },
  //   { value: '/terms/', label: '/terms/' },
  //   { value: '/contactus/', label: '/contactus/' },
  //   { value: '/cities/', label: '/cities/' },
  //   { value: '/driver-terms-or-service/', label: '/driver-terms-or-service/' },
  //   { value: '/vehicle-requirements/', label: '/vehicle-requirements/' },
  //   { value: '/drivers-faq/', label: '/drivers-faq/' },
  // ];

  constructor(
    private dataService: DataService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private messageService: MessageService,
    private titleCasePipe: TitleCasePipe,
  ) {}

  ngOnInit(): void {
    this.initForm();
    this.getData();
    this.route.params.subscribe((params: Params) => {
      this.id = params['id'];
      if (this.id) {
        console.log('Campaign ID found:', this.id);
        //this.getData();
      } else {
        console.log('No Campaign ID found (New Campaign mode)');
      }
    });

    this.isViewOnly = this.router.url.includes('/view/');
    if (this.isViewOnly) {
      this.form.disable();
    }
  }

  ngOnDestroy(): void {
    this.reviewPollingSub?.unsubscribe();
  }

  initForm(): void {
    this.form = this.fb.group({
      title: [''],
      targetKeyword: [''],
      // city: ['', [Validators.required]],
      // service: ['', [Validators.required]],
      // industry: [''],
      //nuevo enfoque
      channel: [''],
      location: ['', [Validators.required]],
      universe: ['', [Validators.required]],
      category: ['', [Validators.required]],
      conversionGoal: ['', [Validators.required]],
      keywordIntent: ['', [Validators.required]],
      keywordMode: ['', [Validators.required]],
      competitionTarget: ['', [Validators.required]],
      objective: ['', [Validators.required]],
      landingStrategy: ['system_suggests'],
      urlStrategy: ['system_suggests'],
      actionType: ['system_suggests'],
      priority: ['high', [Validators.required]],
      notesFocus: [''],
      //hasta aqui
      // landingType: ['', [Validators.required]],
      // targetUrl: ['', [Validators.required]],
      // campaignType: ['', [Validators.required]],
      // status: ['planned'],
      // owner: [''],
      // targetAnchors: this.fb.group({
      //   shortTerm: [[]],
      //   mediumTerm: [[]],
      //   longTerm: [[]],
      // }),
      // suggestedKeywords: this.fb.group({
      //   shortTerm: [[]],
      //   mediumTerm: [[]],
      //   longTerm: [[]],
      // }),
      // suggestedAnchors: this.fb.group({
      //   shortTerm: [[]],
      //   mediumTerm: [[]],
      //   longTerm: [[]],
      // }),
      // targetLocations: this.fb.group({
      //   shortTerm: [[]],
      //   mediumTerm: [[]],
      //   longTerm: [[]],
      // }),
      // notes: [''],
    });
  }

  // Normaliza un ítem del servidor (string o {value,status}) a {value, status}
  private normalizeItem(item: any): { value: string; status: string } {
    if (typeof item === 'string') return { value: item, status: 'active' };
    return { value: item.value || '', status: item.status || 'active' };
  }

  toggleCheckbox(group: string, term: string, value: string, event: any) {
    const checked = event.target.checked;
    const arrayControl = this.form.get(`${group}.${term}`);
    if (!arrayControl) return;

    let currentValues: { value: string; status: string }[] =
      arrayControl.value || [];
    const idx = currentValues.findIndex((item: any) => item.value === value);

    if (checked) {
      // Marcar como activo (o agregar si no existe)
      if (idx >= 0) {
        currentValues[idx] = { ...currentValues[idx], status: 'active' };
      } else {
        currentValues.push({ value, status: 'active' });
      }
    } else {
      // Desmarcar → deshabilitar (no eliminar)
      if (idx >= 0) {
        currentValues[idx] = { ...currentValues[idx], status: 'disabled' };
      }
    }
    arrayControl.setValue([...currentValues]);
  }

  isChecked(group: string, term: string, value: string): boolean {
    const arrayControl = this.form.get(`${group}.${term}`);
    if (!arrayControl) return false;
    const items: { value: string; status: string }[] = arrayControl.value || [];
    const found = items.find((item: any) => item.value === value);
    return !!found && found.status !== 'disabled';
  }

  getItemStatus(group: string, term: string, value: string): string {
    const arrayControl = this.form.get(`${group}.${term}`);
    if (!arrayControl) return 'active';
    const found = (arrayControl.value || []).find(
      (item: any) => item.value === value,
    );
    return found?.status || 'active';
  }

  isFieldInvalid(field: string) {
    return (
      this.form.get(field)?.invalid &&
      (this.form.get(field)?.dirty || this.form.get(field)?.touched)
    );
  }

  onSubmit(): void {
    if (this.form.invalid) {
      return;
    }

    const payload = { ...this.form.getRawValue() };

    if (this.id && !this.newExistingRecord) {
      this.updateData(payload);
    } else {
      this.createData(payload);
    }
  }

  findLocation() {
    const val = this.form.get('location')?.value?.trim();

    if (!val || val.length < 3) {
      this.resultsAvailable = false;
      this.listLocation = [];
      return;
    }

    this.dataService
      .getData(`${this.url_two}/${encodeURIComponent(val)}`)
      .subscribe({
        next: (res: any) => {
          console.log('res', res);

          this.listLocation = Array.isArray(res) ? res : res.data || [];

          this.resultsAvailable = this.listLocation.length > 0;
        },
        error: (err) => {
          console.log(err);
          this.resultsAvailable = false;
          this.listLocation = [];
        },
      });
  }

  locationSelectedAd(result: any) {
    console.log('result', result);
    this.form.patchValue({
      location: `${result.description}`,
    });

    this.resultsAvailable = false;
    this.listLocation = [];
  }

  // getData(): void {
  //   this.dataService.getData(`${this.url}/${this.id}`).subscribe((response) => {
  //     const data = response.data;
  //     console.log('response cam', response);

  //     // Normaliza cada ítem a {value, status} independientemente del formato guardado
  //     const normalizeArray = (
  //       arr: any[],
  //     ): { value: string; status: string }[] =>
  //       (arr || [])
  //         .map((item: any) =>
  //           typeof item === 'string'
  //             ? { value: item, status: 'active' }
  //             : { value: item.value || '', status: item.status || 'active' },
  //         )
  //         .filter((i: any) => i.value);

  //     const formatTerms = (val: any) => {
  //       if (Array.isArray(val)) {
  //         return {
  //           shortTerm: normalizeArray(val),
  //           mediumTerm: [],
  //           longTerm: [],
  //         };
  //       }
  //       return {
  //         shortTerm: normalizeArray(val?.shortTerm),
  //         mediumTerm: normalizeArray(val?.mediumTerm),
  //         longTerm: normalizeArray(val?.longTerm),
  //       };
  //     };

  //     const targetAnchors = formatTerms(data.targetAnchors);
  //     const suggestedKeywords = formatTerms(data.suggestedKeywords);
  //     const suggestedAnchors = formatTerms(data.suggestedAnchors);
  //     const targetLocations = formatTerms(data.targetLocations);

  //     this.form.patchValue({
  //       title: data.title,
  //       targetKeyword: data.targetKeyword,
  //       // city: data.city,
  //       // service: data.service,
  //       // industry: data.industry,
  //       location: data.location,
  //       universe: data.universe,
  //       category: data.category,
  //       conversionGoal: data.conversionGoal,
  //       keywordIntent: data.keywordIntent,
  //       keywordMode: data.keywordMode,
  //       competitionTarget: data.competitionTarget,
  //       objective: data.objective,
  //       landingStrategy: data.landingStrategy,
  //       urlStrategy: data.urlStrategy,
  //       actionType: data.actionType,
  //       priority: data.priority,
  //       notesFocus: data.notesFocus,
  //       //landingType: data.landingType,
  //       //targetUrl: data.targetUrl,
  //       //campaignType: data.campaignType,
  //       //status: data.status,
  //       //owner: data.owner,
  //       //targetAnchors,
  //       //suggestedKeywords,
  //       //suggestedAnchors,
  //       //targetLocations,
  //       //notes: data.notes,
  //     });

  //     // Las opciones disponibles = todos los ítems guardados (activos + deshabilitados)
  //     // this.targetAnchorsOptions = targetAnchors;
  //     // this.suggestedKeywordsOptions = suggestedKeywords;
  //     // this.suggestedAnchorsOptions = suggestedAnchors;
  //     // this.targetLocationsOptions = targetLocations;

  //     if (data.keywords && Array.isArray(data.keywords)) {
  //       const urls = data.keywords
  //         .map((kw: any) => kw.url)
  //         .filter((url: any) => url && url.trim() !== '');
  //       this.uniqueKeywordUrls = [...new Set(urls)].join('\n');
  //       setTimeout(() => {
  //         if (this.textareaUrls && this.textareaUrls.nativeElement) {
  //           const el = this.textareaUrls.nativeElement;
  //           el.style.height = 'auto'; // Reset to auto to compute correct layout
  //           el.style.height = el.scrollHeight + 'px';
  //         }
  //       }, 0);
  //     }

  //     if (this.isViewOnly) {
  //       this.form.disable();
  //     }
  //   });
  // }

  getData(): void {
    this.dataService
      .getDataTwo(this.url, '', this.type, this.currentPage, this.itemsPerPage)
      .subscribe((response) => {
        console.log('response ', response);
        if (response.data) {
          this.data = response.data
            .filter((item: any) => item.status === 'approved')
            .sort((a: any, b: any) => {
              return (
                new Date(b.updatedAt).getTime() -
                new Date(a.updatedAt).getTime()
              );
            });
          this.filteredData = [...this.data];
          this.updateSuggestions();

          // if (this.uniqueLocations && this.uniqueLocations.length > 0) {
          //   this.selectLocation(this.uniqueLocations[0]);
          // }
          // this.selectUniverse('All Services');
          this.filter();
        }
      });
  }

  getReviewsData(id: string) {
    return this.dataService.getData(`${this.url}/${id}`);
  }

  createData(payload: any): void {
    this.isLoading = true;

    this.dataService.postData(`${this.url}/add`, payload).subscribe({
      next: (response) => {
        if (!response.rst) {
          this.messageService.add(response.msg, 'secondary');
          this.isLoading = false;
          return;
        }

        const id = response.data._id || response.data.id;

        this.messageService.add(response.msg, 'info');
        this.form.disable();

        this.reviewPollingSub = interval(30000)
          .pipe(
            startWith(0),
            switchMap(() => this.getReviewsData(id)),
            takeWhile(
              (res: any) => res.data.status !== 'research_complete',
              true,
            ),
          )
          .subscribe({
            next: (res: any) => {
              if (res.data.status === 'research_complete') {
                this.isLoading = false;
                this.reviewPollingSub?.unsubscribe();

                this.router.navigateByUrl(
                  `marketing/seo/offPageCampaigns/reviews/${id}`,
                );
              }
            },
            error: () => {
              this.isLoading = false;
              this.messageService.add(
                'Error consultando recomendaciones',
                'danger',
              );
            },
          });
      },
      error: (e) => {
        this.isLoading = false;
        this.messageService.add('Error creando campaña', 'danger');
      },
    });
  }

  updateData(payload: any): void {
    this.isLoading = true;
    this.dataService
      .putData(`${this.url}/edit/${this.id}`, payload)
      .subscribe((response) => {
        if (response.rst) {
          this.messageService.add(response.msg, 'info');
          //this.router.navigateByUrl('marketing');
          this.getData();
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  goBack(): void {
    this.router.navigateByUrl('marketing');
  }

  deleteData(id: string): void {
    if (!confirm('¿Desea eliminar la campaña?')) {
      return;
    }

    this.dataService
      .deleteData(`${this.url}/delete/${id}`)
      .subscribe((response) => {
        if (response.rst) {
          this.messageService.add(response.msg, 'info');
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
        this.getData();
      });
  }

  approve(id: string): void {
    if (!confirm('¿Desea aprobar esta campaña?')) {
      return;
    }
    this.dataService
      .putData(`${this.url}/${id}/approve`, {})
      .subscribe((response) => {
        if (response.rst) {
          this.messageService.add(response.msg, 'info');
          this.getData();
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  getStatusBadgeClass(status: string): string {
    switch (status) {
      case 'planned':
        return 'badge-secondary';
      case 'research':
        return 'badge-info';
      case 'approved':
        return 'badge-primary';
      case 'in_progress':
        return 'badge-warning';
      case 'completed':
        return 'badge-success';
      case 'paused':
        return 'badge-dark';
      case 'failed':
        return 'badge-danger';
      default:
        return 'badge-light';
    }
  }

  changeStatus(id: string, status: string): void {
    const statusMsg = status === 'in_progress' ? 'iniciar' : 'pausar';
    if (!confirm(`¿Desea ${statusMsg} esta campaña?`)) {
      return;
    }
    this.dataService
      .putData(`${this.url}/${id}/status`, { status })
      .subscribe((response) => {
        if (response.rst) {
          this.messageService.add(response.msg, 'info');
          this.getData();
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  // openAddInput(term: string): void {
  //   if (this.activeAddTerm === term) {
  //     this.activeAddTerm = null;
  //   } else {
  //     this.activeAddTerm = term;
  //   }
  // }

  // confirmAddItem(
  //   field: string,
  //   term: string,
  //   inputElement: HTMLInputElement,
  // ): void {
  //   const value = inputElement.value;
  //   if (!value || value.trim() === '') {
  //     return;
  //   }

  //   this.dataService
  //     .putData(`${this.url}/${this.id}/item-add`, {
  //       field,
  //       term,
  //       value: value.trim(),
  //     })
  //     .subscribe((response) => {
  //       if (response.rst) {
  //         this.messageService.add(response.msg, 'info');
  //         inputElement.value = '';
  //         this.activeAddTerm = null;
  //         this.getData();
  //       } else {
  //         this.messageService.add(response.msg, 'secondary');
  //       }
  //     });
  // }

  complete(id: string): void {
    if (!confirm('¿Desea marcar esta campaña como completada?')) {
      return;
    }
    this.dataService
      .putData(`${this.url}/${id}/complete`, {})
      .subscribe((response) => {
        if (response.rst) {
          this.messageService.add(response.msg, 'info');
          this.getData();
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  get campaignTitle(): string {
    const location = this.titleCasePipe.transform(
      this.form.getRawValue().location || '',
    );

    if (this.isViewOnly) {
      return `${location} SEO Overview`;
    }

    // if (this.id ) {
    //   return `Update Campaign ${location}`;
    // }

    return 'New Keyword Search';
  }

  addKeyword(): void {
    this.searched = false;
    this.hasSearched = false;
    this.locationSelected = false;
    this.universeSelected = false;
    this.selectedLocation = '';
    this.selectedUniverse = '';
    this.selectedCategory = '';

    this.filteredLocations = [...this.uniqueLocations];
    this.filteredUniverses = [...this.uniqueUniverses];
    this.filteredCategories = [...this.uniqueCategories];
    this.formUniverses = [...this.universes];
    this.formCategories = [...this.categories];

    this.matchedCategories.clear();
    this.matchedGoals.clear();
    this.matchedIntents.clear();
    this.matchedModes.clear();
    this.matchedCompetitions.clear();
    this.matchedObjectives.clear();
    this.matchedUniverses.clear();

    this.newExistingRecord = true;
    this.form.reset();
    this.form.enable();
    // this.form.get('location')?.disable();
    
    this.form.patchValue({
      landingStrategy: 'system_suggests',
      urlStrategy: 'system_suggests',
      actionType: 'system_suggests',
      priority: 'high',
    });
  }

  pru() {
    //local
    this.router.navigateByUrl(
      `marketing/seo/offPageCampaigns/reviews/6a90a3494aea3c341099ef5c`,
    );

    //servidor
    // this.router.navigateByUrl(
    //   `marketing/seo/offPageCampaigns/reviews/6a63bf101cb1b38407f799a2`,
    // );
  }

  onLocationSearch(value: string) {
    // User is typing freely — invalidate any previous confirmed selection
    this.locationSelected = false;
    this.hasSearched = false;

    if (!value || value.trim() === '') {
      this.selectedLocation = '';
      this.filteredLocations = [...this.uniqueLocations];
      //this.filter();
      return;
    }

    const text = value.toLowerCase().trim();
    this.selectedLocation = value;
    this.filteredLocations = this.uniqueLocations.filter((city) =>
      city.toLowerCase().includes(text),
    );
    //this.filter();
  }

  selectLocation(city: string) {
    this.selectedLocation = city;
    this.locationSelected = true;
    this.hasSearched = false;
    //this.filter();
  }

  onUniverseSearch(value: string) {
    // User is typing freely — invalidate any previous confirmed selection
    this.universeSelected = false;
    this.hasSearched = false;

    if (!value || value.trim() === '') {
      this.selectedUniverse = '';
      this.filteredUniverses = [...this.uniqueUniverses];
      //this.filter();
      return;
    }

    const text = value.toLowerCase().trim();
    this.selectedUniverse = value;
    this.filteredUniverses = this.uniqueUniverses.filter((universe) =>
      universe.toLowerCase().includes(text),
    );
    //this.filter();
  }

  selectUniverse(universe: string) {
    this.selectedUniverse = universe;
    this.universeSelected = true;
    this.hasSearched = false;
    //this.filter();
  }

  onCategorySearch(value: string) {
    this.hasSearched = false;
    if (!value || value.trim() === '') {
      this.selectedCategory = '';
      this.filteredCategories = [...this.uniqueCategories];
      //this.filter();
      return;
    }

    const text = value.toLowerCase().trim();
    this.selectedCategory = value;

    this.filteredCategories = this.uniqueCategories.filter((category) =>
      category.toLowerCase().includes(text),
    );
    //this.filter();
  }

  selectCategory(category: string) {
    this.selectedCategory = category;
    this.hasSearched = false;
    //this.filter();
  }

  getLocationLabel(value: string): string {
    return this.locations.find((l) => l.value === value)?.label || value;
  }

  getUniverseLabel(value: string): string {
    return this.universes.find((u) => u.value === value)?.label || value;
  }

  getCategoryLabel(value: string): string {
    return this.categories.find((c) => c.value === value)?.label || value;
  }

  displayUniverseFn = (value: string): string => {
    if (!value) return '';
    return this.toTitleCase(this.getUniverseLabel(value));
  };

  displayCategoryFn = (value: string): string => {
    if (!value) return '';
    return this.toTitleCase(this.getCategoryLabel(value));
  };

  toTitleCase(str: string): string {
    if (!str) return '';
    return str.replace(
      /\w\S*/g,
      (txt) => txt.charAt(0).toUpperCase() + txt.substring(1).toLowerCase(),
    );
  }

  filter() {
    this.hasSearched = true;
    const texto = this.searchText?.trim().toLowerCase() || '';
    const locationText = this.selectedLocation?.trim().toLowerCase() || '';
    const universeText = this.selectedUniverse?.trim().toLowerCase() || '';
    const categoryText = this.selectedCategory?.trim().toLowerCase() || '';

    // Require both a location AND a universe to have been explicitly selected
    if (!this.locationSelected || !this.universeSelected) {
      this.filteredData = [];
      return;
    }

    this.filteredData = this.data.filter((item) => {
      const matchText =
        !texto ||
        (item.title && item.title.toLowerCase().includes(texto)) ||
        (item.targetKeyword &&
          item.targetKeyword.toLowerCase().includes(texto)) ||
        (item.universe && item.universe.toLowerCase().includes(texto)) ||
        (item.location && item.location.toLowerCase().includes(texto));

      const matchLocation =
        !locationText ||
        (item.location && item.location.toLowerCase().includes(locationText));

      const matchUniverse =
        !universeText ||
        universeText === 'all universes' ||
        (item.universe && item.universe.toLowerCase().includes(universeText));

      const matchCategory =
        !categoryText ||
        (item.category && item.category.toLowerCase().includes(categoryText));

      return matchText && matchLocation && matchUniverse && matchCategory;
    });
  }

  getRecords(): void {
    if (!this.selectedLocation || !this.selectedUniverse) {
      this.messageService.add(
        'Please select both a search location and universe to find records.',
        'warning',
      );
      return;
    }

    this.searched = true;

    // Use the already fetched this.data populated by getData()
    const locText = this.selectedLocation.trim().toLowerCase();
    const uniText = this.selectedUniverse.trim().toLowerCase();

    const filteredForMatches = this.data.filter((item) => {
      const mLoc =
        item.location && item.location.toLowerCase().includes(locText);
      // 'all universes' means no universe restriction — include all
      const mUni =
        uniText === 'all universes' ||
        (item.universe && item.universe.toLowerCase().includes(uniText));
      return mLoc && mUni;
    });

    this.matchedCategories = new Set(
      filteredForMatches.map((i) => i.category).filter(Boolean),
    );
    this.matchedGoals = new Set(
      filteredForMatches.map((i) => i.conversionGoal).filter(Boolean),
    );
    this.matchedIntents = new Set(
      filteredForMatches.map((i) => i.keywordIntent).filter(Boolean),
    );
    this.matchedModes = new Set(
      filteredForMatches.map((i) => i.keywordMode).filter(Boolean),
    );
    this.matchedCompetitions = new Set(
      filteredForMatches.map((i) => i.competitionTarget).filter(Boolean),
    );
    this.matchedObjectives = new Set(
      filteredForMatches.map((i) => i.objective).filter(Boolean),
    );
    this.matchedUniverses = new Set(
      filteredForMatches.map((i) => i.universe).filter(Boolean),
    );

    // Restrict form universe dropdown based on filter
    if (uniText === 'all universes') {
      this.formUniverses = [...this.universes];
    } else {
      this.formUniverses = this.universes.filter((u) =>
        u.value.toLowerCase().includes(uniText),
      );
    }

    // Restrict form category dropdown based on filter
    const catText = this.selectedCategory?.trim().toLowerCase() || '';
    if (!catText) {
      this.formCategories = [...this.categories];
    } else {
      this.formCategories = this.categories.filter((c) =>
        c.value.toLowerCase().includes(catText),
      );
    }

    if (filteredForMatches.length > 0) {
      const firstRecord = filteredForMatches[0];
      this.form.patchValue({
        location: firstRecord.location || '',
        universe: firstRecord.universe || '',
        category: firstRecord.category || '',
        conversionGoal: firstRecord.conversionGoal || '',
        keywordIntent: firstRecord.keywordIntent || '',
        keywordMode: firstRecord.keywordMode || '',
        competitionTarget: firstRecord.competitionTarget || '',
        objective: firstRecord.objective || '',
        channel: firstRecord.channel || '',
        landingStrategy: firstRecord.landingStrategy || 'system_suggests',
        urlStrategy: firstRecord.urlStrategy || 'system_suggests',
        actionType: firstRecord.actionType || 'system_suggests',
        priority: firstRecord.priority || 'high',
        notesFocus: firstRecord.notesFocus || '',
      });
      // this.messageService.add(
      //   `${filteredForMatches.length} matching records found and populated.`,
      //   'info',
      // );

      this.form.get('location')?.disable();
    } else {
      this.messageService.add(
        `No records found for the selected criteria.`,
        'secondary',
      );
    }
  }

  updateSuggestions() {
    const sugerenciasSet = new Set<string>();
    const citiesSet = new Set<string>();
    const industriesSet = new Set<string>();

    this.data.forEach((item) => {
      if (item.title) sugerenciasSet.add(item.title);
      if (item.targetKeyword) sugerenciasSet.add(item.targetKeyword);
      if (item.location) citiesSet.add(item.location);
      if (item.category) industriesSet.add(item.category);
    });

    this.searchSuggestions = Array.from(sugerenciasSet).filter(Boolean);
    this.uniqueLocations = Array.from(citiesSet).filter(Boolean).sort();
    this.uniqueCategories = Array.from(industriesSet).filter(Boolean).sort();
    this.filteredCategories = [...this.uniqueCategories];

    const servicesSet = new Set<string>();
    this.data.forEach((item) => {
      if (item.universe) servicesSet.add(item.universe);
    });
    this.uniqueUniverses = [
      'All Universes',
      ...Array.from(servicesSet).filter(Boolean).sort(),
    ];
    this.filteredUniverses = [...this.uniqueUniverses];
    this.filteredLocations = [...this.uniqueLocations];

    this.selectedLocation = '';
    this.selectedUniverse = '';
    this.locationSelected = false;
    this.universeSelected = false;

    this.filter();
  }
}
